<template>
  <div id="app">
    <!-- Header Navigation -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container">
        <router-link class="navbar-brand" to="/">Aegent App</router-link>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav me-auto">
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/peoples">Persone (Health)</router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <template v-if="isAuthenticated">
              <li class="nav-item">
                <router-link class="nav-link" to="/projects">Projects</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/people">People</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/budget">Budget</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/dashboard">Dashboard</router-link>
              </li>
              <template v-if="hasRole('admin')">
                <li class="nav-item">
                  <router-link class="nav-link" to="/organisations">Organizzazioni
                    
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/dbmng-test">
                    <i class="fas fa-database me-1"></i>DBMng Test
                  </router-link>
                </li>
              </template>
            </template>
              <!-- ...menu esistente... -->
            </ul>

          <!-- Componente di autenticazione -->
          <div class="d-flex">
            <AuthComponent />
          </div>
        </div>
      </div>
    </nav>

    <!-- Loading indicator -->
    <div v-if="isLoading" class="text-center p-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Caricamento...</span>
      </div>
    </div>

    <!-- Main content -->
    <main class="container my-4">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="bg-light text-center py-3 mt-auto">
      <div class="container">
        <small class="text-muted">&copy; 2025 Aedit s.r.l.</small>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from './stores/app.js'
import { authService } from './services/auth.js'
import AuthComponent from './lib/AuthComponent.vue'

const router = useRouter()
const appStore = useAppStore()

const isLoading = computed(() => appStore.isLoading)
const isAuthenticated = computed(() => appStore.isAuthenticated)
const userName = computed(() => appStore.getUserName)
const hasServerConfig = computed(() => appStore.hasServerConfig)

const hasRole = (role) => {
  return appStore.hasRole(role)
}

// Carica la configurazione del server all'avvio
onMounted(async () => {
  try {
    // Gestione redirect OAuth2 da URL senza hash a hash router
    const currentPath = window.location.pathname
    const currentSearch = window.location.search
    
    if (currentPath === '/auth/callback' && currentSearch.includes('code=')) {
      console.log('🔄 Redirect OAuth2 da URL senza hash a hash router')
      console.log('Current URL:', window.location.href)
      
      // Estrai i parametri
      const urlParams = new URLSearchParams(currentSearch)
      const code = urlParams.get('code')
      const state = urlParams.get('state')
      const error = urlParams.get('error')
      
      // Costruisci l'URL con hash router
      let hashPath = '/auth/callback'
      if (code || state || error) {
        const hashParams = new URLSearchParams()
        if (code) hashParams.set('code', code)
        if (state) hashParams.set('state', state)
        if (error) hashParams.set('error', error)
        hashPath += '?' + hashParams.toString()
      }
      
      console.log('🔄 Redirect to hash path:', hashPath)
      
      // Usa il router di Vue per navigare direttamente al path
      router.replace(hashPath)
      return // ⭐ IMPORTANTE: interrompe l'esecuzione per evitare chiamate duplicate
    }
    
    await appStore.fetchServerConfig()
    console.log('App initialized with server config')
    
    // Tenta di ripristinare la sessione utente se esistente
    await authService.restoreSession()
  } catch (error) {
    console.warn('Failed to load server config, using fallback:', error.message)
  }
})
</script>

<style >
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

.router-link-active {
  font-weight: bold;
}

.text-extreme-danger {
  color: #b235dc !important;
  font-weight: bold;
}
</style>